import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Ostukorvi lisamiseks tee enne lisavalikud

  <span style="color:#85c1dc;">**FI:**</span>
  Lisää ostoskoriin tekemällä ensin lisävalinnat

  <span style="color:#85c1dc;">**RU:**</span>
  Чтобы положить товар в корзину, сделайте дополнительный выбор
*/
/* @__NO_SIDE_EFFECTS__ */
const m1807 = msg(
  mf`Ostukorvi lisamiseks tee enne lisavalikud`,
  mf`Lisää ostoskoriin tekemällä ensin lisävalinnat`,
  mf`Чтобы положить товар в корзину, сделайте дополнительный выбор`,
)

export { m1807 as 'w.module.submission_form.make_choices' }